// GENERAL
function isInViewport(element, offset=25) {
    const el = element.getBoundingClientRect();
    if(!Number.isInteger(offset)){offset = 25; }
    return el.top <= (window.innerHeight - (window.innerHeight * (offset/100)));
}

// ONEPAGERS
function onePagerThreeSubtitle() {
    let subtitles = document.querySelectorAll('article .textwrapper p em');

    if(subtitles.length != 0){
        subtitles.forEach(subtitle => {
            subtitle.classList.add('ani');

            document.addEventListener('scroll', () => {
                if(isInViewport(subtitle)){
                    subtitle.classList.add('ani-ltr');
                }
            });
        });
    }
}

onePagerThreeSubtitle();

function onePagerThreeIntro() {
    let header = document.querySelector('body[data-header="navigation_onepager-03"] div.homeslider');

    if(header) {
        let titel = header.querySelector('h1');
        let slider = header.querySelector('.slickslider');
        let description = header.querySelector('.textwrapper p');

        titel.classList.add('ani');
        slider.classList.add('ani');
        description.classList.add('ani');
        console.log(window.scrollY);

        if(window.scrollY==0){
            console.log('page is on top');
            window.addEventListener('load', () => {
                if(isInViewport(slider)){
                    slider.classList.add('ani-ltr');
                }
                if(isInViewport(titel)){
                    setTimeout(() => {
                        titel.classList.add('ani-ltr');
                    }, 600)
                }
                if(isInViewport(description)){
                    setTimeout(() => {
                        description.classList.add('ani-ltr');
                    }, 800)
                }
            })
        }else if(window.scrollY != 0) {
            console.log('page is not on top');
            window.addEventListener('scroll', () => {
                if(isInViewport(slider)){
                    slider.classList.add('ani-ltr');
                }
                if(isInViewport(titel)){
                    setTimeout(() => {
                        titel.classList.add('ani-ltr');
                    }, 600)
                }
                if(isInViewport(description)){
                    setTimeout(() => {
                        description.classList.add('ani-ltr');
                    }, 800)
                }
            })  
        }
        
    }
}

onePagerThreeIntro();

function onePagerThreeServices() {
    let cards = document.querySelectorAll('.cards .col-12 .textwrapper');

    if(cards.length != 0) {
        console.log('larger')
        

        window.addEventListener('scroll', () => {
            let timing = 150;

            cards.forEach(card => {
                card.classList.add('ani-init');

                if(isInViewport(card)){
                    setTimeout(() =>  {
                        card.classList.add('show');
                    }, timing)

                    timing = timing + 250;
                }
            });
        })
    }
}
onePagerThreeServices();

function onePagerThreeForm() {
    let form = document.querySelector('.sectioncontact .col-12:last-of-type');

    if(form) {
        form.classList.add('ani');

        window.addEventListener('scroll', () => {
            if(isInViewport(form)) {
                form.classList.add('ani-ttb');
            }
        })
    }
}

onePagerThreeForm();

// END ONEPAGERS